// Loaded from CDN (same approach as the backend's TestOpenStreet.html
// prototype) rather than an npm package - no map library exists anywhere
// in this project's package.json, and this avoids a build-time dependency
// change for a couple of map widgets. Shared by LeafletMapPicker (single
// point selection) and LeafletRouteMap (path/route display).
const LEAFLET_CSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
const LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';

let leafletLoadingPromise = null;
export default function loadLeaflet() {
  if (window.L) return Promise.resolve(window.L);
  if (leafletLoadingPromise) return leafletLoadingPromise;
  leafletLoadingPromise = new Promise((resolve, reject) => {
    // The CSS load was previously fire-and-forget (no wait), so L.map()
    // could initialize before leaflet.css actually applied - Leaflet's own
    // stylesheet defines the tile-pane positioning/stacking, so without it
    // present at init time the map can render entirely blank even though
    // the JS loaded fine. Wait for both before resolving.
    let cssReady = false;
    let jsReady = false;
    const maybeResolve = () => { if (cssReady && jsReady) resolve(window.L); };

    const existingLink = document.querySelector(`link[href="${LEAFLET_CSS}"]`);
    if (existingLink) {
      cssReady = true;
    } else {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = LEAFLET_CSS;
      link.onload = () => { cssReady = true; maybeResolve(); };
      link.onerror = () => { cssReady = true; maybeResolve(); }; // don't block forever on a CSS failure
      document.head.appendChild(link);
    }

    const script = document.createElement('script');
    script.src = LEAFLET_JS;
    script.async = true;
    script.onload = () => { jsReady = true; maybeResolve(); };
    script.onerror = () => reject(new Error('leaflet failed to load'));
    document.body.appendChild(script);

    maybeResolve();
  });
  return leafletLoadingPromise;
}
